module.exports = __webpack_public_path__ + "images/ghost.9c7bcf3b.webp";